import React, { Component } from 'react';
import { QueryCSContext } from './../contexts/QueryCSContext';
import './CSStatusFilter.css';

class CSStatusFilter extends Component {
	static contextType = QueryCSContext;

	constructor(props) {
		super(props);
		this.state = {
			filterActive: false,
			filterDraft: false,
			filterRetired: false,
		};

		this.refActive = React.createRef();
		this.refDraft = React.createRef();
		this.refRetired = React.createRef();

		this.handleInputChange = this.handleInputChange.bind(this);
		this.resetFilter = this.resetFilter.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const name = target.name;

		const { setFilterStatus } = this.context;
		//console.log(this);
		const newActive = this.refActive.current.checked;
		const newDraft = this.refDraft.current.checked;
		const newRetired = this.refRetired.current.checked;

		var newStatus = '';
		this.setState({
			filterActive: false,
			filterDraft: false,
			filterRetired: false,
		});

		//console.log(newActive, newDraft, newRetired)

		switch (name) {
			case 'filterActive':
				this.setState({
					filterActive: newActive,
				});
				newStatus = "active";
				break;
			case 'filterDraft':
				this.setState({
					filterDraft: newDraft,
				});
				newStatus = "draft";
				break;
			case 'filterRetired':
				this.setState({
					filterRetired: newRetired,
				});
				newStatus = "retired";
				break;
			default:
				console.log("sw", name);
		}

		if (newActive || newDraft || newRetired) {
			setFilterStatus(newStatus)
		}
		else {
			setFilterStatus('')
		}
	}

	resetFilter(e) {
		e.preventDefault();

		this.setState({
			filterActive: false,
			filterDraft: false,
			filterRetired: false,
		});

		const { setFilterStatus } = this.context;
		setFilterStatus('');
	}
	render() {
		return (
			<div className="csStatusFilter">
				<p className="csStatusFilter__title">Status</p>
				<div className="csStatusFilter__options">
					<label className="csStatusFilter__label">
						<input
							type="checkbox"
							onChange={this.handleInputChange}
							checked={this.state.filterDraft}
							name="filterDraft"
							ref={this.refDraft}
						/>
						<span>Draft</span>
					</label>
					<label className="csStatusFilter__label">
						<input
							type="checkbox"
							onChange={this.handleInputChange}
							checked={this.state.filterActive}
							name="filterActive"
							ref={this.refActive}
						/>
						<span>Active</span>
					</label>
					<label className="csStatusFilter__label">
						<input
							type="checkbox"
							onChange={this.handleInputChange}
							checked={this.state.filterRetired}
							name="filterRetired"
							ref={this.refRetired}
						/>
						<span>Retired</span>
					</label>
					<span
						onClick={this.resetFilter}
						className="csStatusFilter__reset"
						href="#"
					>
						Clear Filter
					</span>
				</div>
			</div>
		);
	}
}

export default CSStatusFilter;
